import React, { useState } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';

// Layout Components
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { WhatsAppButton } from './components/layout/WhatsAppButton';
import { AuditModal } from './components/forms/AuditModal';

// Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Work } from './pages/Work';
import { Insights } from './pages/Insights';
import { BlogPost } from './pages/BlogPost';
import { ServicePage } from './pages/ServicePage';
import { IndustryPage } from './pages/IndustryPage';
import { LocationServicePage } from './pages/LocationServicePage';

// Data
import { allLocationPages } from './data/locationServices';

function App() {
  const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);

  const openAuditModal = () => setIsAuditModalOpen(true);
  const closeAuditModal = () => setIsAuditModalOpen(false);

  return (
    <div className="App bg-[#F7F7F7] min-h-screen">
      <BrowserRouter>
        <Header onOpenAuditModal={openAuditModal} />
        
        <Routes>
          <Route path="/" element={<Home onOpenAuditModal={openAuditModal} />} />
          <Route path="/about" element={<About onOpenAuditModal={openAuditModal} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/work" element={<Work onOpenAuditModal={openAuditModal} />} />
          <Route path="/insights" element={<Insights onOpenAuditModal={openAuditModal} />} />
          <Route path="/blog/:slug" element={<BlogPost onOpenAuditModal={openAuditModal} />} />
          {/* Location-based SEO Landing Pages - Specific routes with slug passed as prop */}
          {allLocationPages.map((page) => (
            <Route 
              key={page.slug}
              path={`/services/${page.slug}`} 
              element={<LocationServicePage onOpenAuditModal={openAuditModal} pageSlug={page.slug} />} 
            />
          ))}
          <Route path="/services/:slug" element={<ServicePage onOpenAuditModal={openAuditModal} />} />
          <Route path="/industries/:slug" element={<IndustryPage onOpenAuditModal={openAuditModal} />} />
        </Routes>
        
        <Footer />
        <WhatsAppButton />
        <AuditModal isOpen={isAuditModalOpen} onClose={closeAuditModal} />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
